import * as React from 'react';
import { Facebook } from './Facebook';
import { Google } from './Google';
import { Lock } from './Lock';
import { Mail } from './Mail';

export type IconTypes = 'lock' | 'facebook' | 'mail' | 'google';

interface Props {
  type: IconTypes;
}

const icons = {
  lock: Lock,
  facebook: Facebook,
  mail: Mail,
  google: Google
};

export const Icon: React.SFC<Props> = ({ type, ...props }) => {
  const IconType = icons[type];
  return <IconType {...props} />;
};
